import "./App.css";
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import GuestRoutes from "./routes/guest-routes";
import UserRoutes from "./routes/user-routes";
import Admin from "./pages/admin/admin";
import AppLayout from "./layouts/app-layout";
import ProtectedRoute from "./utils/ProtectedRoute";
import UserBookAppointments from "./pages/user-book-appointments/user-book-appointments";
import RescheduleConfirmation from "./pages/user-book-appointments/reschedule-confirmation/reschedule-confirmation";

const App: React.FC = () => {
  const isUserSiteEnabled = process.env.REACT_APP_USER_SITE_ENABLED;

  return (
    <Routes>
      {/* Default route based on whether the user site is enabled */}
      <Route
        path="/"
        element={
          isUserSiteEnabled ? (
            <Navigate to="/user-app" replace />
          ) : (
            <Navigate to="/admin" replace />
          )
        }
      />

      {/* Guest routes */}
      <Route path="/*" element={<GuestRoutes />} />

      {/* User site routes (only if enabled) */}
      {isUserSiteEnabled && (
        <>
          <Route
            path="/user-app"
            element={
              <AppLayout isHideNavbar>
                <UserBookAppointments />
              </AppLayout>
            }
          />
          <Route
            path={`/user-app/reschedule-confirmation`}
            element={
              <AppLayout isHideNavbar>
                <RescheduleConfirmation />
              </AppLayout>
            }
          />
        </>
      )}

      {/* Admin site routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />

      {/* Admin dashboard routes */}
      {<Route path="/dashboard/*" element={<UserRoutes />} />}
    </Routes>
  );
};

export default App;
